import React, { useEffect, useState } from "react";
import {
  BellIcon,
  CrossIcon,
  SearchIcon,
  ToggleIcon,
  ToggleIcon2,
} from "./Icon";
import adamSmith from "../../assets/images/png/adam_smith_img.png";
import { useStateProvider } from "./StateProvider";
import NotificaitonModal from "../notificaiton/NotificaitonModal";

const Header = ({ text }) => {
  const [mobileNav, setMobileNav] = useState(false);
  const { setShowData } = useStateProvider(); //OPEN SIDEBAR
  const [notificaitonModal, setNotificaitonModal] = useState(false); //Notificaiton Modal

  useEffect(() => {
    if (mobileNav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [mobileNav]);

  // OVERLAY BEHIND MOBILENAV
  const overLayHidden = () => {
    setMobileNav(!mobileNav);
  };
  // OVERLAY BEHIND Notificaiton Modal
  const notificaitonOverLay = () => {
    setNotificaitonModal(notificaitonModal);
    setNotificaitonModal(false);
  };

  useEffect(() => {
    if (notificaitonModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [notificaitonModal]);
  return (
    <>
      <div className="sm:flex items-center justify-between  top-0 px-0 py-4 z-0  min-h-full ">
        <div
          className={`fixed top-0  flex flex-col items-cente bg-[#6F6AF8] h-full w-[300px]  gap-14 justify-center z-20 lg:hidden duration-300 ease-in-out overflow-hidden  ${
            mobileNav ? "right-0" : "right-[-990px]"
          }`}>
          <span
            className="absolute top-4 right-4 cursor-pointer"
            onClick={() => setMobileNav(!mobileNav)}>
            <CrossIcon />
          </span>
          <div className="flex flex-col">
            <div className="flex  border border-solid border-[#929292] ps-2 py-2  items-center rounded-[50px] sm:w-[300px] md:w-[343px]">
              <span className="opacity-70">
                <SearchIcon />
              </span>
              <input
                className="ff_poppins font-normal text-[14px] text-black bg-transparent placeholder:text-black/70 placeholder:opacity-70 px-[10px] outline-none w-11/12"
                type="text"
                placeholder="Search here..."
              />
            </div>
            <div className="flex items-center justify-start pt-4 gap-3 xl:gap-6 bell_icon">
              <span
                className="cursor-pointer bellIcon-btn duration-300"
                onClick={() => setNotificaitonModal(true)}>
                <BellIcon />
              </span>
              <div className="flex gap-2 items-center">
                <img
                  className=" max-w-[36px] w-full"
                  src={adamSmith}
                  alt="adam-Smith"
                />
                <div>
                  <h5 className="ff_poppins text-[14px] font-normal text-white">
                    Adam Smith
                  </h5>
                  <p className="ff_poppins text-[10px] 3xl:text-[12px] font-light text-white opacity-70">
                    Manager profile
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center pb-4 sm:pb-0">
          <button
            aria-label="Openlink"
            className="  lg:hidden"
            onClick={() => setShowData(true)}>
            <ToggleIcon2 />
          </button>
          <h2
            className={` font-semibold text-[18px] xs:text-[20px]  xl:text-[24px] 3xl:text-[28px] text-black sm:pl-3 lg:pl-0`}>
            {text}
          </h2>

          <div className="flex gap-3 items-center sm:hidden ">
            <span
              className="cursor-pointer bellIcon-btn sm:hidden"
              onClick={() => setNotificaitonModal(true)}>
              <BellIcon />
            </span>
            <img
              className=" max-w-[36px] w-full"
              src={adamSmith}
              alt="adam-Smith"
            />
            <div className="hidden xm:block">
              <h5 className="ff_poppins text-[14px] font-normal text-black">
                Adam Smith
              </h5>
              <p className="ff_poppins text-[10px] 3xl:text-[12px] font-light text-black opacity-70">
                Manager profile
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-between pt-2 sm:pt-0 gap-5">
          <div className="flex  border border-solid border-[#929292] ps-2 py-2  items-center rounded-[50px] w-full sm:w-[250px] md:w-[280px] lg:w-[343px]">
            <span className=" opacity-70">
              <SearchIcon />
            </span>
            <input
              className="ff_poppins font-normal text-[14px] text-black bg-transparent placeholder:text-black/70 placeholder:opacity-70 placeholder:font-normal px-[10px] outline-none w-11/12"
              type="text"
              placeholder="Search here..."
            />
          </div>

          <div className="flex items-center gap-3 xl:gap-6 ">
            <span
              className="cursor-pointer bellIcon-btn hidden sm:block"
              onClick={() => setNotificaitonModal(true)}>
              <BellIcon />
            </span>
            <div className=" gap-2 items-center hidden  sm:flex ">
              <img
                className=" max-w-[36px]  w-full"
                src={adamSmith}
                alt="adam-Smith"
              />
              <div className="hidden md:block">
                <h5 className="ff_poppins text-[14px] font-normal text-black">
                  Adam Smith
                </h5>
                <p className="ff_poppins text-[10px] 3xl:text-[12px] font-light text-black opacity-70">
                  Manager profile
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={overLayHidden}
        className={` fixed inset-0 min-h-full z-10  bg-black opacity-10 ${
          mobileNav ? "w-[100%] " : "hidden"
        }`}></div>

      <div className=" fixed right-0 xm:right-16 z-50 top-20">
        {notificaitonModal && (
          <NotificaitonModal setNotificaitonModal={setNotificaitonModal} />
        )}
      </div>
      <div
        onClick={notificaitonOverLay}
        className={` fixed inset-0 min-h-full z-40  bg-black opacity-10 ${
          notificaitonModal ? "w-[100%] " : "hidden"
        }`}></div>
    </>
  );
};

export default Header;
